import { useTranslation } from 'react-i18next';

export default function LoadingPage() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center min-h-screen bg-secondary-50 dark:bg-secondary-900">
      <div className="text-center">
        {/* Spinner */}
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 dark:border-primary-500 mb-4"></div>
        <p className="text-secondary-600 dark:text-secondary-400">{t('common.loading')}</p>
      </div>
    </div>
  );
}
















































